import getMockBusinessInsightsDashboard from '@/pages/admin/dashboard/helpers/getMockBusinessInsightsDashboard';
import type { UseGetAdminBusinessInsightsDashboardResult } from './types';

const useGetAdminBusinessInsightsDashboard = (): UseGetAdminBusinessInsightsDashboardResult => ({
    dashboard: getMockBusinessInsightsDashboard(),
});

export default useGetAdminBusinessInsightsDashboard;
